<template>
  <div v-if="permission.access">
    <validation-observer ref="loginValidation">
      <b-form
        class="auth-login-form mt-2"
        @submit.prevent
        enctype="multipart/form-data"
      >
        <b-card>
          <b-form-group label="Title" label-for="title">
            <validation-provider
              #default="{ errors }"
              name="title"
              rules="required"
            >
              <b-form-input
                id="title"
                v-model="form.title"
                :state="errors.length > 0 ? false : null"
                name="title"
                placeholder="Enter Your Section Title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group label="Select Photo" label-for="title">
            <b-form-file
              multiple
              id="student_work"
              accept=".jpg, .png, .gif"
              @change="workImage($event)"
              placeholder="Select Photo"
              drop-placeholder="Drop file here..."
            />
          </b-form-group>
          <div>
            <div
              class="d-inline-block image_div"
              v-for="(image, index) in images"
              :key="index"
              v-if="images.length"
            >
              <div class="image_delete" @click="deleteImage(index)">X</div>
              <b-img
                :src="image"
                height="100"
                width="167"
                class="rounded mr-2 mb-1"
              />
            </div>

            <div
              class="d-inline-block image_div"
              v-for="(image, index) in show_images"
              :key="index + '_2'"
              v-if="show_images.length"
            >
              <div class="image_delete" @click="PermanentDeleteImage(image.id)">
                X
              </div>
              <b-img
                :src="image.link"
                height="100"
                width="167"
                class="rounded mr-2 mb-1"
              />
            </div>
          </div>
        </b-card>
        <div class="d-flex justify-content-end mb-5">
          <b-button type="submit" variant="primary" @click="validationForm">
            Update
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BButton,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardTitle,
  BImg,
  BForm,
  BFormTextarea,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    BCard,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BMediaAside,
    BMediaBody,
  },
  data() {
    return {
      required,
      email,
      form: {
        title: "",
        images: [],
      },
      images: [],
      show_images: [],
      permission: {
        access: false,
      },
    };
  },
  mounted() {
    this.Permission();
    this.edit();
  },
  methods: {
    async edit() {
      const cit_photo_wall = await this.callApi(
        "post",
        "/app/cit/photo/wall/show"
      );
      if (cit_photo_wall.status == 200) {
        this.form.title = cit_photo_wall.data.heading.title;
        this.images = [];
        this.show_images = [];
        this.form.images = [];
        cit_photo_wall.data.images.forEach((image) => {
          this.show_images.push({
            id: image.id,
            link: this.$store.state.base_url + image.image,
          });
        });
      }
    },
    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "cit.photo.wall.manage") {
          this.permission.access = true;
        }
      });
    },

    async PermanentDeleteImage(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't to delete it!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post("/app/cit/photo/wall/delete/" + id)
            .then((res) => {
              this.s(res.data.message);
              this.edit();
            })
            .catch((e) => {
              if (e.response.status === 422) {
                if (e.response.data.errors.title) {
                  this.e(e.response.data.errors.title[0]);
                }
                if (e.response.data.errors.images) {
                  this.e(e.response.data.errors.images[0]);
                }
              }
            });
        }
      });
    },
    deleteImage(index) {
      this.form.images.splice(index, 1);
      this.images.splice(index, 1);
    },

    workImage(e) {
      e.target.files.forEach((data) => {
        this.form.images.push(data);
        let reader = new FileReader();
        reader.onload = (e) => {
          this.images.push(e.target.result);
        };
        reader.readAsDataURL(data);
      });
    },

    add() {
      const fd = new FormData();
      var self = this;
      if (this.form.images.length) {
        for (let i = 0; i < this.form.images.length; i++) {
          let file = self.form.images[i];
          fd.append("images[" + i + "]", file);
        }
      }

      fd.append("title", this.form.title);

      axios
        .post("/app/cit/photo/wall/store", fd)
        .then((res) => {
          this.s(res.data.message);
          this.edit();
          // this.$router.push("/course");
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.title) {
              this.e(e.response.data.errors.title[0]);
            }
            if (e.response.data.errors.images) {
              this.e(e.response.data.errors.images[0]);
            }
          }
        });
    },

    validationForm() {
      this.$refs.loginValidation.validate().then((success) => {
        if (success) {
          this.add();
        }
      });
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.image_div {
  position: relative;
}
.image_delete {
  width: 25px;
  height: 25px;
  font-weight: bold;
  line-height: 25px;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 5px;
  right: 30px;
  background: rgba(0, 0, 0, 0.548);
  cursor: pointer;
  border-radius: 50%;
}
</style>
